import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api, { apiError, TOKEN_KEY, TENANT_KEY } from "../api";
import { useAuth } from "../AuthContext";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

const black = "#111111";

export default function ActivareCampanie() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [state, setState] = useState("loading"); // loading | ok | error
  const [message, setMessage] = useState("");
  const done = useRef(false);
  const token = params.get("token") || "";

  // Fiecare clic pe butonul din email intra direct in aplicatie: verificam linkul,
  // apoi activam/logam automat si ducem userul in /site.
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    if (!token) { setState("error"); setMessage("Link invalid. Token lipsa."); return; }
    (async () => {
      try {
        const info = await api.get(`/auth/campaign-info?token=${encodeURIComponent(token)}`);
        if (info.data.expired) { setState("error"); setMessage("Link expirat. Contactati office@yvola.eu."); return; }
        const { data } = await api.post("/auth/activate-campaign", { token });
        localStorage.setItem(TOKEN_KEY, data.access_token);
        if (data.tenant_id) localStorage.setItem(TENANT_KEY, data.tenant_id);
        setState("ok");
        if (refresh) await refresh();
        setTimeout(() => { window.location.href = "/site"; }, 900);
      } catch (err) {
        setState("error");
        setMessage(apiError(err, "Link invalid sau expirat."));
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6"
      style={{ backgroundColor: "#ffffff", color: black, fontFamily: "Arial, sans-serif", fontSize: "12px" }}>
      <div className="w-full max-w-md text-center border border-gray-200 rounded-lg p-8" data-testid="activare-campanie-page">
        <div style={{ fontSize: "22px", fontWeight: "bold", letterSpacing: "1px", marginBottom: "18px" }}>YVOLA</div>

        {state === "loading" && (
          <>
            <Loader2 className="w-8 h-8 animate-spin mx-auto mb-4" style={{ color: black }} />
            <p style={{ fontSize: "13px" }}>Te conectam in aplicatie...</p>
          </>
        )}

        {state === "ok" && (
          <>
            <div className="w-14 h-14 rounded-md border border-gray-300 flex items-center justify-center mx-auto mb-6">
              <CheckCircle2 className="w-7 h-7" style={{ color: black }} />
            </div>
            <h2 style={{ fontSize: "20px" }} className="font-bold" data-testid="activare-success">Bine ai venit</h2>
            <p className="mt-2" style={{ fontSize: "13px" }}>Te ducem in aplicatie...</p>
          </>
        )}

        {state === "error" && (
          <>
            <div className="w-14 h-14 rounded-md border border-gray-300 flex items-center justify-center mx-auto mb-6">
              <XCircle className="w-7 h-7" style={{ color: black }} />
            </div>
            <h2 style={{ fontSize: "20px" }} className="font-bold" data-testid="activare-error">Link invalid</h2>
            <p className="mt-2" style={{ fontSize: "13px" }}>{message}</p>
            <Link to="/login" className="mt-6 inline-block underline">Mergi la autentificare</Link>
          </>
        )}
      </div>
    </div>
  );
}
